module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_doctor-cdf6742a2d720c02c9e267f1b478a5ea.svg";